module.exports = __webpack_public_path__ + "img/ic_company-logo_13.124a87de.svg";